import {ApolloClient, InMemoryCache, ApolloLink, Observable} from '@apollo/client';
import fetch from 'cross-fetch';
import {onError} from '@apollo/client/link/error';
import {refreshAndGetToken} from 'js/reusable/auth/tool';

let isRefreshing = false;
let pendingRequests = [];

const FB_GRAPH_QUERY_NAMES = [
	'externalAdAccountsAggregated',
	'externalAdAccounts',
	'extendedCreditInvoiceGroups',
	'deposits',
	'updateDeposit',
	'statistics',
	'transactionsExternal',
	'createCustomer',
	'customers',
	'walletPaymentInstructions',
	'externalAdvertisers',
	'createDeposit',
	'externalAdAccountActivity',
	'updateExternalAdAccount',
	'deleteCreditSettings',
	'updateCreditSettings',
	'updateCustomer',
	'updateSpendCap',
	'refreshExternalAdAccounts',
	'countries',
	'importSettings',
	'updateAdminUser',
	'createAdminUser',
	'updateImportSetting',
	'deleteImportSetting',
];

function resolvePendingRefreshRequests(newToken) {
	pendingRequests.map(pendingObject => {
		pendingObject.operation.setContext(({headers = {}}) => ({
			headers: {
				...headers,
				authorization: `Bearer ${newToken}`,
			},
		}));

		pendingObject.forward(pendingObject.operation).subscribe(pendingObject.subscriber);

		return pendingObject.resolve();
	});
	pendingRequests = [];
}

export function getClient(httpLink) {
	const authMiddleware = new ApolloLink(async (operation, forward) => {
		let queryNames = '';

		try {
			queryNames = operation.query.definitions
				.map(
					def => def.selectionSet.selections.map(sel => sel.name.value)
				)
				.flat()
				.filter(queryName => FB_GRAPH_QUERY_NAMES.includes(queryName))
				.join(',');
		} catch (e) {
			queryNames = '';
		}

		operation.setContext(({headers = {}}) => ({
			headers: {
				...headers,
				authorization:            `Bearer ${localStorage.getItem('accessToken') || null}`,
				'X-GRAPH-OPERATION-NAME': queryNames,
			},
		}));

		return forward(operation);
	});

	const errorLink = new onError(({graphQLErrors, operation, forward, networkError}) => {
		if (
			graphQLErrors && graphQLErrors[0].code === 1001 ||
			networkError && networkError.statusCode === 496 ||
			networkError && networkError.statusCode === 403 ||
			networkError && networkError.statusCode === 401
		) {
			return new Observable(async observer => {
				const subscriber = {
					next:     observer.next.bind(observer),
					error:    observer.error.bind(observer),
					complete: observer.complete.bind(observer),
				};

				if (!isRefreshing) {
					isRefreshing = true;

					const newToken = await refreshAndGetToken();

					await resolvePendingRefreshRequests(newToken);

					operation.setContext(({headers = {}}) => ({
						headers: {
							...headers,
							authorization: `Bearer ${newToken}`,
						},
					}));

					isRefreshing = false;

					forward(operation).subscribe(subscriber);
				} else {
					new Promise(resolve => {pendingRequests.push({operation, forward, resolve, subscriber});});
				}
			});
		}
	});

	return new ApolloClient({
		fetch,
		cache: new InMemoryCache(),
		link:  ApolloLink.from([authMiddleware, errorLink, httpLink]),
	});
}
